export const SET_ROLE_DATA = "SET_ROLE_DATA";
export const ROLE_FETCHING_INIT = "ROLE_FETCHING_INIT";
export const SET_ROLES = "SET_ROLES";
export const ROLE_FETCHING_COMPLETED = "ROLE_FETCHING_COMPLETED";
